import React, { useEffect, useState } from "react";
import Head from "../../layout/head/Head";
import { useForm } from "react-hook-form";
import Content from "../../layout/content/Content";
import { Block, Col, PreviewAltCard, Row } from "../../components/Component";
import { toast } from "react-toastify";
import Table from "../../MyComp/UI/DataTable/Table";
import {
  listMedicineAPI,
  createMedicineAPI,
  updateMedicineAPI,
  approveMedicineAPI
} from "../../api/master/indes";
import { BASE_URL_IMG } from "../../assets/constants";
import useLogout from "../../hooks/useLogout";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";
import MyInput from "../../MyComp/UI/form/MyInput";
import MyButton from "../../MyComp/UI/form/MyButton";
import Status from "../../MyComp/UI/form/Status";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import {
  Form,
  Offcanvas,
  OffcanvasBody,
  OffcanvasHeader,
} from "reactstrap";
const ListMedicine = () => {
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      isLoading: false,
      medicine_img: null,
      medicine_image: null,
    },
  });

  const logout = useLogout();
  const [data, setData] = useState([]);
  const [tableLoading, setTableLoading] = useState(true);
  const [isOpen, setIsOpen] = useState(false);
  const [approveRejectModal, setApproveRejectModal] = useState(false);
  const [currentRow, setCurrentRow] = useState(null);
  const [currentAction, setCurrentAction] = useState("");
  const [mode, setMode] = useState("Add");
  const isLoading = watch("isLoading");

  useEffect(() => {
    getMedicineList();
  }, []);

  const getMedicineList = () => {
    listMedicineAPI()
      .then((res) => {
        if (res.data.status === "expired") {
          setTableLoading(false);
          toast.error(res.data.message);
          logout();
        } else if (res.data.status === true) {
          setData(res.data.data);
          setTableLoading(false);
        } else {
          setData([]);
          setTableLoading(false);
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        setTableLoading(false);
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  const openApproveRejectModal = (row, action) => {
    setCurrentRow(row);
    setCurrentAction(action);
    setApproveRejectModal(true);
  };

  const handleApproveReject = (row, action) => {
    const body = { Id: row?.Id, MedicineName: row?.MedicineName, medicineStatus: action };
    approveMedicineAPI(body)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(`${action === "approve" ? "Approved" : "Rejected"} successfully`);
          getMedicineList();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Something went wrong");
      });
  };

  // ================= RESET =================
  const resetF = () => {
    setMode("Add");
    setValue("MedicineName", "");
    setValue("Packing", "");
    setValue("MRP", "");
    setValue("GST", "");
    setValue("Brand", "");
    setValue("Type", "");
    setValue("Remark", "");
    setValue("status", null);
    setValue("medicine_img", null);
    setValue("medicine_image", null);
    setValue("selectedRow", null);
  };

  const toggleCanvas = () => {
    setIsOpen(!isOpen);
    if (isOpen) resetF();
  };

  // ================= SUBMIT =================
  const onFormSubmit = () => {
    const formData = new FormData();

    formData.append("MedicineName", watch("MedicineName"));
    formData.append("Packing", watch("Packing"));
    formData.append("MRP", watch("MRP"));
    formData.append("GST", watch("GST"));
    formData.append("Brand", watch("Brand"));
    formData.append("Type", watch("Type"));
    formData.append("Remark", watch("Remark"));
    formData.append(
      "Status",
      watch("status")?.value ? "true" : "false"
    );

    if (watch("medicine_img")) {
      formData.append("ImageUrl", watch("medicine_img"));
    }

    if (mode === "Edit") {
      formData.append("Id", watch("selectedRow")?.Id);
    }

    const apiCall =
      mode === "Add" ? createMedicineAPI : updateMedicineAPI;

    apiCall(formData)
      .then((res) => {
        if (res.data.status === true) {
          toast.success(
            `Medicine ${mode === "Add" ? "Added" : "Updated"} successfully`
          );
          getMedicineList();
          toggleCanvas();
          resetF();
        } else {
          toast.error(res.data.message);
        }
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message || "Error saving data");
      });
  };

  // ================= EDIT =================
  const handleEdit = (row) => {
    setMode("Edit");
    setIsOpen(true);
    setValue("selectedRow", row);
    setValue("MedicineName", row?.MedicineName);
    setValue("Packing", row?.Packing);
    setValue("MRP", row?.MRP);
    setValue("GST", row?.GST);
    setValue("Brand", row?.Brand);
    setValue("Type", row?.Type);
    setValue("Remark", row?.Remark);
    setValue("medicine_image", `${BASE_URL_IMG}${row?.ImageUrl}`);
    setValue("medicine_img", `${BASE_URL_IMG}${row?.ImageUrl}`);
    setValue("status", {
      label: row.Status === "true" ? "Active" : "Inactive",
      value: row.Status === "true",
    });
  };
  return (
    <>
      <Head title={"Medicine | Master"} />
      <Content>
        <Block>

          {/* OFFCANVAS FORM */}
          <Offcanvas isOpen={isOpen} direction="end">
            <OffcanvasHeader toggle={toggleCanvas}>
              {mode} Medicine
            </OffcanvasHeader>

            <OffcanvasBody>
              <PreviewAltCard>
                <Form onSubmit={handleSubmit(onFormSubmit)}>
                  <Row>
                    <Col md="12">
                      <MyInput
                        title="Medicine Name"
                        name="MedicineName"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        required
                        placeholder={"Enter Medicine Name"}
                      />
                    </Col>

                    <Col md="12">
                      <MyInput
                        title="Packing"
                        name="Packing"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        required
                        placeholder={"Enter Packing"}
                      />
                    </Col>

                    <Col md="6">
                      <MyInput
                        title="MRP"
                        name="MRP"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        required
                        placeholder={"Enter MRP"}
                      />
                    </Col>

                    <Col md="6">
                      <MyInput
                        title="GST"
                        name="GST"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                        placeholder={"Enter GST"}
                      />
                    </Col>

                    <Col md="6">
                      <MyInput title="Brand"
                        name="Brand"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        placeholder={"Enter Brand Name"}
                        errors={errors}
                      />
                    </Col>

                    <Col md="6">
                      <MyInput title="Type"
                        name="Type"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        placeholder={"Enter Type"}
                        errors={errors}

                      />
                    </Col>

                    <Col md="12">
                      <MyInput
                        title="Remark"
                        name="Remark"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        placeholder={"Enter Remark"}
                        errors={errors}
                      />
                    </Col>

                    <Col md="12">
                      <ImageUpload
                        id="medicine_image"
                        image="medicine_img"
                        image_url="medicine_image"
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        clearErrors={clearErrors}
                        label="Upload Medicine Image"
                        getValues={getValues}
                      />
                    </Col>

                    <Col md="12">
                      <Status
                        register={register}
                        watch={watch}
                        setValue={setValue}
                        trigger={trigger}
                        errors={errors}
                      />
                    </Col>
                  </Row>

                  <div className="mt-3">
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Form>
              </PreviewAltCard>
            </OffcanvasBody>
          </Offcanvas>
          <Table
            title="Medicine List"
            data={data}
            columns={[
              { key: "ImageUrl", label: "MedicineName", type: "image" },
              { key: "MedicineName", label: "Medicine Name" },
              { key: "MRP", label: "MRP" },
              { key: "Packing", label: "Packing" },
            ]}
            searchKeys={["MedicineName"]}
            nameColumn={"MedicineName"}
            approveRejectEnabled={true}
            handleApproveReject={(row, action) => openApproveRejectModal(row, action)}
            isLoading={tableLoading}
            // medicineStatus
            imageBaseURL={BASE_URL_IMG}
            onEditClick={handleEdit}
            toggleCanvas={toggleCanvas}
            setIsOpen={setIsOpen}
            resetF={resetF}
          />

          <Modal isOpen={approveRejectModal} toggle={() => setApproveRejectModal(false)}>
            <ModalHeader toggle={() => setApproveRejectModal(false)}>
              {currentAction} Medicine
            </ModalHeader>
            <ModalBody>
              Are you sure you want to {currentAction.toLowerCase()} the medicine{" "}
              <strong>{currentRow?.MedicineName}</strong>?
            </ModalBody>
            <ModalFooter>
              <Button color="secondary" onClick={() => setApproveRejectModal(false)}>
                Cancel
              </Button>
              <Button
                color={currentAction === "Approve" ? "success" : "danger"}
                onClick={() => {
                  handleApproveReject(currentRow, currentAction.toLowerCase());
                  setApproveRejectModal(false);
                }}
              >
                Confirm
              </Button>
            </ModalFooter>
          </Modal>
        </Block>
      </Content>
    </>
  );
};

export default ListMedicine;
